module.exports = __webpack_public_path__ + "static/media/logo hessnature.2174faaf.png";